import { Drawer } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import React, { useEffect, useState } from 'react'
import Land from '../../Assets/images/tar1.png'
import ActiveSavingsCom from './ActiveSavingsCom';
import Note from '../../Assets/images/note.svg';
import getServices from '../../Services/get-service';
import Constant from '../../Constant';

const drawerWidth = 650;

function TargetSavingDrawer({ open, handleClose, window }) {
    const [savings, setSavings] = useState([])
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        getServices.getAllSavingsPlanByUser()
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setSavings(response.data.data || []);
                }
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            });
    }, [])

    const filteredData = savings.filter(item => item.savingsType === 'TARGET');

    return (
        <div>

            <Drawer
                anchor='right'
                variant="temporary"
                open={open}
                onClose={handleClose}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                    display: { xs: 'block', sm: 'block' },
                    '& .MuiDrawer-paper': {
                        boxSizing: 'border-box',
                        width: { xs: '100%', sm: drawerWidth },
                        backgroundColor: 'white'
                    },
                }}
            >
                <div>
                    <div className=' p-4 border-b border-b-[#f0f0f0] flex justify-between'>
                        <p className=' text-back-color2 text-[18px] pt-3'>Target savings plans</p>
                        <div className='pt-2'>
                            <CancelIcon onClick={handleClose} className=' text-back-color2 text-[38px]' fontSize="large" />
                        </div>
                    </div>


                </div>
                <div className='p-3 grid md:grid-cols-1 gap-3'>
                    {loading ? (
                        <>
                            {[1, 2, 3].map((item) => (
                                <ActiveSavingsCom key={item} loading={true} />
                            ))}
                        </>
                    ) : (
                        <>
                            {filteredData.map(e => {

                                return <div key={e.id}>
                                    <ActiveSavingsCom
                                        img={Land}
                                        title={e.planName}
                                        sub={e.currentBalance}
                                        link={`plan/${e.planName}/details/${e.savingsWalletId}/${Constant.FormatNumber(e.currentBalance || 0)}/${e.planName}/${e.endDate}/${e.startDate}/${Math.ceil((e.currentBalance / e.targetAmount) * 100)}/${Math.ceil(e.targetAmount)}/${e.savingsStatus}/${e.currentBalance || 0}`}
                                    />
                                </div>
                            })}

                            {filteredData.length === 0 && (
                                <div className="flex flex-col items-center justify-center py-10">
                                    <img src={Note} alt="No active plan" className="mb-4 w-16 h-16" />
                                    <p className="text-center text-gray-500 font-medium">
                                        No active target savings plan
                                    </p>
                                </div>
                            )}
                        </>
                    )}
                </div>

            </Drawer>
        </div>
    )
}

export default TargetSavingDrawer
